import { organisationsApi } from '~/services/organisations-api/organisationsApi';
import { useSession } from '~/features/auth/context/Session';
import { useState } from 'react';
import { UserMetadata } from '~/services/organisations-api/types';

export function useUserMetaData() {
  const { session, getLatestSession } = useSession();
  const [userMetaData, setUserMetaData] = useState<UserMetadata>(
    () => (session?.identity?.metadata_public as UserMetadata) ?? {}
  );

  const { mutateAsync: updateUserMetaData } = organisationsApi.useMutation('put', '/users/metadata', {
    onSettled: () => {
      async function getUpToDateSession() {
        const newSession = await getLatestSession();
        if (newSession) {
          setUserMetaData(newSession.identity?.metadata_public as UserMetadata);
        }
      }
      getUpToDateSession();
    },
  });

  return { updateUserMetaData, userMetaData: userMetaData };
}
